import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { MariaDBTableDataset } from 'app/model/dataset/maria-db.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.mariaDB.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(MariaDBTableDataset) }
})
export class MariaDBCopySource extends TabularCopySource {
}
